import { Sidebar } from "@/components/styleguide/Sidebar";
import { ARCHITECTURE_NAV } from "@/data/architectureNav";
import { ArchitectureHero } from "@/components/architecture/ArchitectureHero";
import { OverviewSection } from "@/components/architecture/sections/OverviewSection";
import { NavMapSection } from "@/components/architecture/sections/NavMapSection";
import { JourneysSection } from "@/components/architecture/sections/JourneysSection";
import { HomeSection } from "@/components/architecture/sections/HomeSection";
import { LearnSection } from "@/components/architecture/sections/LearnSection";
import { HomeworkSection } from "@/components/architecture/sections/HomeworkSection";
import { RewardsSection } from "@/components/architecture/sections/RewardsSection";
import { ProgressSection } from "@/components/architecture/sections/ProgressSection";
import { ProfileSection } from "@/components/architecture/sections/ProfileSection";
import { ModesSection } from "@/components/architecture/sections/ModesSection";
import { SensorySection } from "@/components/architecture/sections/SensorySection";
import { FeedbackSection } from "@/components/architecture/sections/FeedbackSection";
import { AgeSection } from "@/components/architecture/sections/AgeSection";
import { TimelineSection } from "@/components/architecture/sections/TimelineSection";
import { FooterSection } from "@/components/styleguide/sections/FooterSection";

export default function ArchitecturePage() {
  return (
    <div className="App min-h-screen overflow-x-clip bg-background text-foreground antialiased">
      <Sidebar items={ARCHITECTURE_NAV} subtitle="Experience Architecture" />
      <main className="lg:pl-72">
        <ArchitectureHero />
        <div className="mx-auto w-full max-w-content px-5 sm:px-8 lg:px-12">
          <OverviewSection />
          <NavMapSection />
          <JourneysSection />
          <HomeSection />
          <LearnSection />
          <HomeworkSection />
          <RewardsSection />
          <ProgressSection />
          <ProfileSection />
          <ModesSection />
          <SensorySection />
          <FeedbackSection />
          <AgeSection />
          <TimelineSection />
        </div>
        <FooterSection />
      </main>
    </div>
  );
}
